import { render, staticRenderFns } from "./CompletedActivity.vue?vue&type=template&id=63af6e72"
import script from "./CompletedActivity.vue?vue&type=script&lang=js"
export * from "./CompletedActivity.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports